module.exports = __webpack_public_path__ + "img/ENGIE.970a5f24.png";